var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgView(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    t: 1719107297080,
    className: "icon",
    viewBox: "0 0 1024 1024",
    xmlns: "http://www.w3.org/2000/svg",
    "p-id": 9091,
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M512 85.333333C276.053333 85.333333 85.333333 277.333333 85.333333 512c0 235.648 191.018667 426.666667 426.666667 426.666667s426.666667-191.018667 426.666667-426.666667S747.648 85.333333 512 85.333333zM256 298.666667h384v85.333333H341.333333v213.333333H256V298.666667z m128 128h384v298.666666H384v-298.666666z m85.333333 85.333333v128h213.333334v-128h-213.333334z",
    "p-id": 9092,
    fill: "#333"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgView);
export default __webpack_public_path__ + "static/media/view.c19e568299a0ae95e2cf359afa5a0202.svg";
export { ForwardRef as ReactComponent };